import { useChangeActiveCompanyMutation, useGetCompanyByIdQuery } from '@/api'
import { appStore, useAppSelector } from '@/store'
import { useModal } from './useModal'
import { ModalType } from '@/store/app'

export const useCompany = () => {
  const { showModal, hideModal } = useModal()
  const {
    user,
    userCompanies,
    activeCompany,
    activeHasBranches,
    currentHasBranches,
  } = useAppSelector(appStore)
  const [changeActiveCompany] = useChangeActiveCompanyMutation()

  const changeCompany = async (companyId?: number) => {
    if (companyId) {
      try {
        showModal(ModalType.ORGANIZATION_CHANGE)
        const responce = await changeActiveCompany({ id: companyId })
        if (responce) {
          window.location.reload()
        } else {
          hideModal()
        }
      } catch (e) {
        hideModal()
        console.log(e)
      }
    }
  }

  return {
    user,
    userCompanies: Array.isArray(userCompanies) ? userCompanies : [],
    activeCompany,
    activeHasBranches,
    currentHasBranches,
    changeCompany,
  }
}
